module.exports = __webpack_public_path__ + "static/assets/09b839560df34635b28bf171e66ee288.svg";